import { request } from "common";
/**登录 */
export function login(data) {
  return request({
    url: "/auth/oauth/token",
    method: "post",
    data: data,
    headers:{
      Authorization: "Basic YWRtaW4td2ViOlVWTVI5a1UwVDdQeVBrREV3bUNv",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    otherToken:true
  });
}
/**获取验证码 */
export function loginCaptcha() {
  return request({
    url: "/captcha",
    method: "get",
  });
}


export function logout() {
  return request({
    url: "/auth/oauth/logout",
    method: "get",
  });
}
